<template>
  <el-empty v-if="!loading && !detail" description="没有找到订单信息..." />
  <div v-else class="wrap">
    <!--操作提示区-->
    <div class="tip primary">
      <dl class="text-info text-sm">
        <dt class="text-warning">
          <i class="el-icon-bell" />
          操作提示
        </dt>
        <dd>页面打印建议：根据数据行数量，A4纵向打印/A5横向打印。</dd>
      </dl>
      <div class="btns">
        <el-link v-if="detail.State == 1" type="primary" icon="el-icon-edit"
          @click="$router.push({ path: 'form', query: { id: detail.Id } })">
          修改
        </el-link>
        <el-link type="primary" icon="el-icon-magic-stick" @click="toSale">
          转销售
        </el-link>
        <el-link type="primary" icon="el-icon-printer" v-print="'#print'">
          打印
        </el-link>
      </div>
    </div>
    <!--打印区-->
    <div class="paper" id="print">
      <table>
        <thead>
          <tr>
            <th colspan="8">
              <h1 style="font-size: 20px">昆明莱尔公司订货申请表</h1>
              <p style="color: #f56c6c">{{ detail.Code }}</p>
            </th>
          </tr>
          <tr>
            <td colspan="8">
              <p style="
                  padding: 10px;
                  display: flex;
                  justify-content: space-between;
                ">
                <span>部门：{{ detail.Dept.Name }}</span>
                <span>客户：{{ detail.Customer }}</span>
                <span>
                  日期：{{ $utils.common.parseTime(detail.CreateTime, "{y} 年 {m} 月 {d} 日") }}
                </span>
              </p>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>存货编码</th>
            <th colspan="2">品名及规格</th>
            <th>单位</th>
            <th>单价</th>
            <th>数量</th>
            <th>销售价格</th>
            <th>发货备注</th>
          </tr>
          <tr v-for="(row, index) in detail.Items" :key="index">
            <th>{{ row.Code }}</th>
            <td colspan="2">{{ row.Name }} {{ row.Spec }}</td>
            <th>{{ row.Unit }}</th>
            <th>
              <template v-if="row.Price">￥{{ row.Price }}</template>
            </th>
            <th>{{ row.Quantity }}</th>
            <th>
              <template v-if="row.Price">
                ￥{{
    Math.round(row.Price * row.Quantity * 100) / 100
  }}
              </template>
            </th>
            <td></td>
          </tr>
          <tr class="blank">
            <th></th>
            <th colspan="2"></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <td colspan="2">按实际订货开票：⬜是 ⬜否</td>
            <td colspan="2">下预付款：⬜是 ⬜否</td>
            <td colspan="4" rowspan="2">
              <P>签订销售合同或平台下单：⬜是 ⬜否</P>
              <P>预计收款时间：</P>
            </td>
          </tr>
          <tr>
            <td colspan="2">开票内容：</td>
            <td colspan="2">过单业务：⬜是 ⬜否</td>
          </tr>
          <tr>
            <td colspan="8">
              备注：{{ detail.Remarks }} {{ detail.Code }}
            </td>
          </tr>
          <tr>
            <td colspan="8">
              以上货物如造成积压，由申请人员负责处理消化并承担损失。公司非主营产品急需外采，客户未签订合同或线上下单未完成，需由部门经理签字同意，并承担相应风险。
            </td>
          </tr>
          <tr>
            <td colspan="3">建议供方（参考）：</td>
            <td colspan="2">联系人：</td>
            <td colspan="3">联系电话：</td>
          </tr>
        </tbody>
        <tfoot>
          <tr style="height: 50px;vertical-align: baseline;">
            <td colspan="3">申请人：</td>
            <td colspan="2">运营经理/主管/商务签字：</td>
            <td colspan="3">经理签字：</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      detail: null,
    };
  },
  created() {
    this.loading = true;
    this.$apis.product.purchase
      .detail({ id: this.$route.params.id })
      .then((res) => {
        this.detail = res || [];
      })
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    totalQuantity() {
      return this.detail.Items.reduce((acc, cur) => {
        return acc + (cur.Quantity || 0);
      }, 0);
    },
    totalPrice() {
      let val = this.detail.Items.reduce((acc, cur) => {
        return acc + (cur.Quantity || 0) * (cur.Price || 0);
      }, 0);

      if (val) {
        return `￥${Math.round(val * 100) / 100}`;
      }
      return null;
    },
  },
  methods: {
    toSale() {
      this.$confirm("将此采购申请转为销售申请, 是否继续?", "转销售", {
        center: true,
      }).then(() => {
        this.$apis.product.purchase
          .tosale({ id: this.detail.Id })
          .then((res) => {
            this.$router.replace({
              path: `/product/presale/${res}`,
            });
            this.$message({
              type: "success",
              message: "转换成功，请完善信息（如商品价格）！",
            });
          });
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.wrap {
  min-height: 100%;
  display: flex;
  flex-direction: column;

  .tip {
    position: relative;

    .btns {
      position: absolute;
      right: 30px;
      bottom: 30px;
    }
  }

  .paper {
    flex: 1;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    padding: 48px;

    table {
      flex: 1;
      min-width: 720px;
      height: 100%;
    }
  }
}

//输出到打印页面
@media print {
  .no-print {
    display: none;
  }
}

h1 {
  font-size: 24px;
}

.paper {
  height: 100%;

  table {
    page-break-after: always;
    height: 100%;
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    border: 1px solid transparent;
    font-size: 12px;

    tbody {
      height: 100%;
    }

    tbody,
    tfoot {
      tr {

        th,
        td {
          word-break: break-all;
          font-weight: normal;
          height: 30px;
          padding: 5px 10px;
          border: 1px solid #000;
        }

        &.blank {
          height: inherit;
        }
      }
    }

    .client {
      span+span {
        margin-left: 10px;
      }
    }
  }
}
</style>
